// import { interviewOutcomeResponse } from "../data/mock/aura-interview-outcome-response-mock-data.js";
// import { updateConditionsResponse } from "../data/mock/update-conditions-response-mock-data.js";

import { auraWordingList } from "../data/auraExclusionWordingList.js";
//** Config  */
import { OUTCOME_STAGE, POLICY_OUTCOME } from "../config/const/enums.js";

import { matchAuraStatus } from "../utilities/preQualificationUtils.js";

const exclusionCodeMapping = (exclusionCodes, coverType) => {
  //* Match the code with the values returned from the eLife Aura data

  const exclusionWords = [];

  exclusionCodes.map((item) => {
    const auraItem = auraWordingList().find(
      (elm) =>
        elm.auraExclusionCode.trim() === item.trim() &&
        elm.riskTypeCode.trim() === coverType.trim()
    );
    if (auraItem != null) {
      exclusionWords.push(auraItem.exclusionWording);
    }
  });
  return exclusionWords;
};

function isObjEmpty(obj) {
  return obj === undefined || obj === null || Object?.keys(obj)?.length === 0;
}

function mapAdditionalExclusions(exclusionCodes = []) {
  if (exclusionCodes?.length === 0) return [];

  let mappedExclusionCode = [];

  exclusionCodes.forEach((item) => {
    mappedExclusionCode.push({ name: item });
  });

  return mappedExclusionCode;
}

export const mapCoverDetails = (covers, state = null) => {
  if (!covers) return;
  try {
    const { upsell } = { ...covers };

    const lifeCovers = covers?.criticalIllness ? covers?.life : covers?.life;

    //* Ensure we have the correct CI Cover values
    const ciCovers = covers?.criticalIllness
      ? covers?.criticalIllness
      : covers?.criticalIllness;

    //* Ensure we have the correct PUW Cover values
    const puwCovers = covers?.unableToWork
      ? covers?.unableToWork
      : covers?.unableToWork;

    //* Ensure we have the correct CI Cover values
    // const lifeCovers = covers?.criticalIllness
    // 	? covers?.life
    // 	: state?.covers?.life;

    // //* Ensure we have the correct CI Cover values
    // const ciCovers = covers?.criticalIllness
    // 	? covers?.criticalIllness
    // 	: state?.covers?.criticalIllness;

    // //* Ensure we have the correct PUW Cover values
    // const puwCovers = covers?.unableToWork
    // 	? covers?.unableToWork
    // 	: state?.covers?.unableToWork;

    /* #region ****  Life **** */
    const hasLifeCover = lifeCovers?.sumInsured === 0 ? false : true;
    const hasLifeDecline = !!lifeCovers?.declineReasonList?.length;
    const hasLifeLoading =
      hasLifeCover && (lifeCovers?.totalLoading > 0 || lifeCovers?.loading > 0)
        ? true
        : false;
    const hasAdditionalLifeLoading =
      hasLifeCover && lifeCovers?.loading > 0 ? true : false; //? NB: loading  represents additional loadings set with updateCondition API call,

    //* NEW: Additional Life Loading Display
    //* Must be in the format {display : "25%"}
    const additionalLifeLoadingDisplay =
      hasLifeCover && lifeCovers?.loading > 0 ? `${lifeCovers?.loading}%` : "";
    const additionalLifeLoadingAmount =
      hasLifeCover && lifeCovers?.loading > 0 ? lifeCovers?.loading : null;

    //* NEW: Additional Life Exclusions Display (additionalExclusionsCode from updateConditions API)
    //* Must be in the format [{name : "AFLYIN"}]
    const additionalLifeExclusionsDisplay =
      mapAdditionalExclusions(lifeCovers?.additionalExclusionCodes) || [];
    const additionalLifeExclusionsValues =
      lifeCovers?.additionalExclusionCodes || [];

    //* NEW: Aura added Exclusions that are to be removed from list of exclusions available in the dropdowns. (exclusionCodes from updateConditions API)
    //* Must be in the format ["ABASEJ"]

    //! *************** NOTE: TODO: FIX THIS: exclusionCodes = AURA EXCLUSIONS AND ADDED EXCLUSIONS - WE ONLY WANT AURA EXCLUSIONS HERE
    const auraLifeExclusions = lifeCovers?.exclusionCodes?.filter(
      (el) => !lifeCovers?.additionalExclusionCodes?.includes(el)
    );
    const excludedLifeExclusions = auraLifeExclusions || [];
    /* #endregion */

    /* #region ****  Critical Illness *****/
    const hasCriticalIllnessCover =
      ciCovers?.sumInsured != null &&
      ciCovers?.sumInsured !== 0 &&
      !ciCovers?.declineReasonList?.length;
    // !ciCovers?.declineReasonList?.length;
    const hasCriticalIllnessUpSell = !isObjEmpty(upsell);
    const hasCriticalIllnessDecline = !!ciCovers?.declineReasonList?.length;
    const hasCriticalIllnessLoading =
      hasCriticalIllnessCover &&
      (ciCovers?.totalLoading > 0 || ciCovers?.loading > 0)
        ? true
        : false;
    const hasAdditionalCriticalIllnessLoading =
      hasCriticalIllnessCover && ciCovers?.loading > 0 ? true : false;

    //* NEW Additional Critical Illness Loading Display
    //* Must be in the format {display : "25%"}
    const additionalCriticalIllnessLoadingDisplay =
      hasCriticalIllnessCover && ciCovers?.loading > 0
        ? `${ciCovers?.loading}%`
        : "";
    const additionalCriticalIllnessLoadingAmount =
      hasCriticalIllnessCover && ciCovers?.loading > 0
        ? ciCovers?.loading
        : null;

    //* NEW Additional Life Exclusions Display (additionalExclusionsCode from updateConditions API)
    //* Must be in the format [{name : "AFLYIN"}]
    const additionalCriticalIllnessExclusionsDisplay =
      mapAdditionalExclusions(ciCovers?.additionalExclusionCodes) || [];
    const additionalCriticalIllnessExclusionsValues =
      ciCovers?.additionalExclusionCodes || [];

    //* NEW Aura added Exclusions that are to be removed from list of exclusions available in the dropdowns. (exclusionCodes from updateConditions API)
    //* Must be in the format ["ABASEJ"]
    const auraCriticalIllnessExclusions = ciCovers?.exclusionCodes?.filter(
      (el) => !ciCovers?.additionalExclusionCodes?.includes(el)
    );
    const excludedCriticalIllnessExclusions =
      auraCriticalIllnessExclusions || [];
    /* #endregion */

    /* #region **** Unable to work **** */
    const hasUnableToWorkCover =
      puwCovers?.sumInsured != null &&
      puwCovers?.sumInsured !== 0 &&
      !puwCovers?.declineReasonList?.length;
    const hasUnableToWorkDecline = !!puwCovers?.declineReasonList?.length;

    const hasUnableToWorkLoading =
      hasUnableToWorkCover &&
      (puwCovers?.totalLoading > 0 || puwCovers?.loading > 0)
        ? true
        : false;
    const hasAdditionalUnableToWorkLoading =
      hasUnableToWorkCover && puwCovers?.loading > 0 ? true : false;

    //* NEW Additional Unable to Work Loading Display
    //* Must be in the format {display : "25%"}
    const additionalUnableToWorkLoadingDisplay =
      hasUnableToWorkCover && puwCovers?.loading > 0
        ? `${puwCovers?.loading}%`
        : "";
    const additionalUnableToWorkLoadingAmount =
      hasUnableToWorkCover && puwCovers?.loading > 0
        ? puwCovers?.loading
        : null;

    //* NEW Additional Life Exclusions Display (additionalExclusionsCode from updateConditions API)
    //* Must be in the format [{name : "AFLYIN"}]
    const additionalUnableToWorkExclusionsDisplay =
      mapAdditionalExclusions(puwCovers?.additionalExclusionCodes) || [];
    const additionalUnableToWorkExclusionsValues =
      puwCovers?.additionalExclusionCodes || [];

    //* NEW Aura added Exclusions that are to be removed from list of exclusions available in the dropdowns. (exclusionCodes from updateConditions API)
    //* Must be in the format ["ABASEJ"]
    const auraUnableToWorkExclusions = puwCovers?.exclusionCodes?.filter(
      (el) => !puwCovers?.additionalExclusionCodes?.includes(el)
    );
    const excludedUnableToWorkExclusions = auraUnableToWorkExclusions || [];
    /* #endregion */

    /* #region Additional Loading/Exclusion Count */
    const lifeAdditionalLoadingCount =
      lifeCovers?.loading > 0 ? [lifeCovers?.loading].length : 0;
    const lifeAdditionalExclusionCount =
      lifeCovers?.additionalExclusionCodes?.length || 0;

    const ciAdditionalLoadingCount =
      ciCovers?.loading > 0 ? [ciCovers?.loading].length : 0;
    const ciAdditionalExclusionCount = ciCovers?.length || 0;

    const puwAdditionalLoadingCount =
      covers?.unableToWork?.loading > 0
        ? [covers?.unableToWork?.loading].length
        : 0;
    const puwAdditionalExclusionCount = covers?.unableToWork?.length || 0;

    const totalAdditionalConditions =
      lifeAdditionalLoadingCount +
      lifeAdditionalExclusionCount +
      ciAdditionalLoadingCount +
      ciAdditionalExclusionCount +
      puwAdditionalLoadingCount +
      puwAdditionalExclusionCount;

    /* #endregion Additional Loading/Exclusion Count End */

    /* #region flags */
    const hasAnyExclusions =
      !!lifeCovers?.exclusionCodes?.length ||
      !!lifeCovers?.additionalExclusionCodes?.length ||
      !!ciCovers?.exclusionCodes?.length ||
      !!ciCovers?.additionalExclusionCodes?.length ||
      !!puwCovers?.exclusionCodes?.length ||
      !!puwCovers?.additionalExclusionCodes?.length;

    const hasAnyDeclined =
      !!lifeCovers?.declineReasonList?.length ||
      !!ciCovers?.declineReasonList?.length ||
      !!puwCovers?.declineReasonList?.length;

    const hasAnyLoading =
      hasLifeLoading || hasCriticalIllnessLoading || hasUnableToWorkLoading;
    /* #endregion */

    //* Cover Information
    const coverDetails = {
      anyExclusions: hasAnyExclusions,
      anyDeclined: hasAnyDeclined,
      anyLoading: hasAnyLoading,
      anyExclusionsOrLoadings: hasAnyLoading || hasAnyExclusions,
      hasLifeCover: hasLifeCover,
      hasLifeDecline: hasLifeDecline,
      hasLifeLoading: hasLifeLoading,
      hasAdditionalLifeLoading: hasAdditionalLifeLoading,
      additionalLifeLoadingDisplay: additionalLifeLoadingDisplay,
      additionalLifeLoadingAmount: additionalLifeLoadingAmount,
      additionalLifeExclusionsDisplay: additionalLifeExclusionsDisplay,
      additionalLifeExclusionsValues: additionalLifeExclusionsValues,
      excludedLifeExclusions: excludedLifeExclusions,
      totalAdditionalConditions: totalAdditionalConditions,
      hasLifeExclusion:
        !!lifeCovers?.exclusionCodes?.length ||
        !!lifeCovers?.additionalExclusionCodes?.length,
      hasAdditionalLifeExclusion:
        !!lifeCovers?.additionalExclusionCodes?.length,
      hasLifeExclusionOrLoadings:
        !!lifeCovers?.exclusionCodes?.length ||
        !!lifeCovers?.additionalExclusionCodes?.length ||
        hasLifeLoading,
      hasAdditionalLifeExclusionOrLoadings:
        !!lifeCovers?.additionalExclusionCodes?.length ||
        hasAdditionalLifeLoading, //* Used to set the edit checkbox for additional loading or/and exclusions

      life: {
        sumInsured: lifeCovers?.sumInsured,
        auraStatus: lifeCovers?.auraStatus,
        auraStatusDisplay: matchAuraStatus(lifeCovers?.auraStatus),
        monthly: lifeCovers?.premiums?.monthly || lifeCovers?.monthly,
        annual: lifeCovers?.premiums?.annual || lifeCovers?.annual,
        declineReasonList: lifeCovers?.declineReasonList,
        additionalLoading: lifeCovers?.loading || 0,
        totalLoading: lifeCovers?.totalLoading || 0,
        showExclusionCodes:
          !!lifeCovers?.exclusionCodes?.length ||
          !!lifeCovers?.additionalExclusionCodes?.length,
        exclusionCodes: !lifeCovers?.exclusionCodes
          ? []
          : exclusionCodeMapping(
              [
                ...new Set([
                  ...lifeCovers?.exclusionCodes,
                  ...(lifeCovers?.additionalExclusionCodes || []),
                ]),
              ],
              "LIF"
            ),
        rawAuraExclusionCodes: !!auraLifeExclusions?.length
          ? auraLifeExclusions
          : [],
        additionalExclusionCodes: !!lifeCovers?.additionalExclusionCodes?.length
          ? lifeCovers?.additionalExclusionCodes
          : [],
      },
      hasCriticalIllnessCover: hasCriticalIllnessCover,
      hasCriticalIllnessUpSell: hasCriticalIllnessUpSell,
      hasCriticalIllnessDecline: hasCriticalIllnessDecline,
      hasCriticalIllnessLoading: hasCriticalIllnessLoading,
      hasAdditionalCriticalIllnessLoading: hasAdditionalCriticalIllnessLoading,
      additionalCriticalIllnessLoadingDisplay:
        additionalCriticalIllnessLoadingDisplay,
      additionalCriticalIllnessLoadingAmount:
        additionalCriticalIllnessLoadingAmount,
      additionalCriticalIllnessExclusionsDisplay:
        additionalCriticalIllnessExclusionsDisplay,
      additionalCriticalIllnessExclusionsValues:
        additionalCriticalIllnessExclusionsValues,
      excludedCriticalIllnessExclusions: excludedCriticalIllnessExclusions,
      hasCriticalIllnessExclusion: !!ciCovers?.exclusionCodes?.length,
      hasAdditionalCriticalIllnessExclusion:
        !!ciCovers?.additionalExclusionCodes?.length,
      hasCriticalIllnessExclusionOrLoadings:
        !!ciCovers?.exclusionCodes?.length ||
        !!ciCovers?.additionalExclusionCodes?.length ||
        hasCriticalIllnessLoading,
      hasAdditionalCriticalIllnessExclusionOrLoadings:
        !!ciCovers?.additionalExclusionCodes?.length ||
        hasAdditionalCriticalIllnessLoading, //* Used to set the edit checkbox for additional loading or/and exclusions
      ...((hasCriticalIllnessCover === true ||
        hasCriticalIllnessDecline === true ||
        hasCriticalIllnessUpSell === true) && {
        criticalIllness: {
          sumInsured:
            hasCriticalIllnessUpSell === true
              ? upsell?.amount
              : ciCovers?.sumInsured === 0
                ? ""
                : ciCovers?.sumInsured,
          auraStatus: ciCovers?.auraStatus,
          auraStatusDisplay: matchAuraStatus(ciCovers?.auraStatus),
          monthly:
            hasCriticalIllnessUpSell === true
              ? upsell?.monthlyPremium
              : ciCovers?.premiums?.monthly || ciCovers?.monthly,
          annual:
            hasCriticalIllnessUpSell === true
              ? upsell?.annualPremium
              : ciCovers?.premiums?.annual || ciCovers?.annual,
          declineReasonList: ciCovers?.declineReasonList,
          additionalLoading: ciCovers?.loading || 0,
          totalLoading: ciCovers?.totalLoading || 0,
          showExclusionCodes: !!ciCovers?.exclusionCodes?.length,
          exclusionCodes: !ciCovers?.exclusionCodes
            ? []
            : exclusionCodeMapping(
                [
                  ...new Set([
                    ...ciCovers?.exclusionCodes,
                    ...(ciCovers?.additionalExclusionCodes || []),
                  ]),
                ],
                "CI"
              ),
          rawAuraExclusionCodes: !!auraCriticalIllnessExclusions?.length
            ? auraCriticalIllnessExclusions
            : [],
          additionalExclusionCodes: !!covers?.criticalIllness
            ?.additionalExclusionCodes?.length
            ? ciCovers?.additionalExclusionCodes
            : [],
          upSellSums: {
            premium: upsell?.amount || "",
            monthly: upsell?.monthlyPremium || "",
            annual: upsell?.annualPremium || "",
          },
        },
      }),
      hasUnableToWorkCover: hasUnableToWorkCover,
      hasUnableToWorkDecline: hasUnableToWorkDecline,
      hasUnableToWorkLoading: hasUnableToWorkLoading,
      hasAdditionalUnableToWorkLoading: hasAdditionalUnableToWorkLoading,
      additionalUnableToWorkLoadingDisplay:
        additionalUnableToWorkLoadingDisplay,
      additionalUnableToWorkLoadingAmount: additionalUnableToWorkLoadingAmount,
      additionalUnableToWorkExclusionsDisplay:
        additionalUnableToWorkExclusionsDisplay,
      additionalUnableToWorkExclusionsValues:
        additionalUnableToWorkExclusionsValues,
      excludedUnableToWorkExclusions: excludedUnableToWorkExclusions,
      hasUnableToWorkExclusion: !!puwCovers?.exclusionCodes?.length,
      hasAdditionalUnableToWorkExclusion:
        !!puwCovers?.additionalExclusionCodes?.length,
      hasUnableToWorkExclusionOrLoadings:
        !!puwCovers?.exclusionCodes?.length ||
        !!puwCovers?.additionalExclusionCodes?.length ||
        hasUnableToWorkLoading,
      hasAdditionalUnableToWorkExclusionOrLoadings:
        !!puwCovers?.additionalExclusionCodes?.length ||
        hasAdditionalUnableToWorkLoading, //* Used to set the edit checkbox for additional loading or/and exclusions
      ...((hasUnableToWorkCover === true ||
        hasUnableToWorkDecline === true) && {
        unableToWork: {
          sumInsured: puwCovers?.sumInsured === 0 ? "" : puwCovers?.sumInsured,
          auraStatus: puwCovers?.auraStatus,
          auraStatusDisplay: matchAuraStatus(puwCovers?.auraStatus),
          monthly: puwCovers?.premiums?.monthly || puwCovers?.monthly,
          annual: puwCovers?.premiums?.annual || puwCovers?.annual,
          declineReasonList:
            puwCovers?.declineReasonList || puwCovers?.declineReasonList,
          totalLoading: puwCovers?.totalLoading || 0,
          additionalLoading: puwCovers?.loading || 0,
          showExclusionCodes: !!puwCovers?.exclusionCodes?.length,
          exclusionCodes: !puwCovers?.exclusionCodes
            ? []
            : exclusionCodeMapping(
                [
                  ...new Set([
                    ...puwCovers?.exclusionCodes,
                    ...(puwCovers?.additionalExclusionCodes || []),
                  ]),
                ],
                "PUW"
              ),
          rawAuraExclusionCodes: !!auraUnableToWorkExclusions?.length
            ? auraUnableToWorkExclusions
            : [],
          additionalExclusionCodes: !!puwCovers?.unableToWork
            ?.additionalExclusionCodes?.length
            ? puwCovers?.additionalExclusionCodes
            : [],
        },
      }),
    };

    // console.log(JSON.stringify(coverDetails, true, 2));
    return coverDetails;
  } catch (ex) {
    return console.log("ERROR ", ex);
  }
};

export const interviewAuraOutcomeMapping = (inputData) => {
  const response = {};
  if (inputData == null) return response;

  //* Flatten out the response as much as possible
  response.revisionNo = inputData.revisionNo;

  const policyState = {
    contractStage: inputData.state.contractStage,
    contractStageDisplay: OUTCOME_STAGE[inputData?.state?.contractStage] || "",
    processStatus: inputData.state.processStatus,
    processStatusDisplay: POLICY_OUTCOME[inputData?.state?.processStatus] || "",
  };
  response.policyState = policyState;

  const { insuredParticipants } = { ...inputData };
  const {
    covers,
    underwritingQuestions,
    insuredPremiums,
    messageList,
    basicDetails,
  } = {
    ...insuredParticipants[0],
  };
  const { upsell } = { ...covers };
  response.uid = insuredParticipants[0].uid;
  response.auraStatus = insuredParticipants[0]?.auraStatus;
  response.auraStatusDisplay = matchAuraStatus(
    insuredParticipants[0]?.auraStatus
  );
  response.title = basicDetails.title;
  response.firstName = basicDetails.firstName;
  response.surname = basicDetails.surname;

  const generalQuote = {
    quoteNumber: inputData.quoteNumber,
    policyPremiumsTotal: {
      monthly: insuredPremiums?.monthly,
      annual: insuredPremiums?.annual,
    },
  };
  response.quoteInformation = generalQuote;

  //* Map the cover details.
  response.covers = mapCoverDetails(covers);
  response.messageList = messageList;
  response.upsell = upsell;
  response.underwritingQuestions = underwritingQuestions;

  response.ok = true;
  // console.log("INTERVIEW AURA OUTCOME: ", JSON.stringify(response, true, 2));
  return response;
};

// interviewAuraOutcomeMapping(interviewOutcomeResponse("lifeOnly"));
// interviewAuraOutcomeMapping(updateConditionsResponse());
